import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import Social from "./Social";
import ScrollToTop from "./ScrollToTop";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

const Contact = () => {
  const { elementRef, isVisible } = useRevealOnScroll();
  const [state, handleSubmit] = useForm("myzyydva");
  const { language } = useLanguage();
  const t = translations[language];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!state.submitting) {
      await handleSubmit(e);
      if (state.succeeded) {
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      }
    }
  };

  return (
    <section
      id="contact"
      ref={elementRef}
      className={`px-6 py-20 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <h1 className="mb-4 text-center font-title text-3xl font-bold text-white">
        {t.contact.title}
      </h1>
      <p className="mx-auto mb-10 max-w-xl text-center text-gray-300">
        {t.contact.body}
      </p>

      <div className="mx-auto mt-4 max-w-md rounded-lg bg-gray-900 p-6 shadow-lg ring-1 ring-gray-800">
        <form onSubmit={handleFormSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="mb-1 block text-sm text-gray-300">
              {t.contact.nameLabel}
            </label>
            <input
              id="name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-sm text-white focus:border-coding-color focus:outline-none"
            />
            <ValidationError
              prefix="Name"
              field="name"
              errors={state.errors}
              className="mt-1 text-sm text-red-500"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="email"
              className="mb-1 block text-sm text-gray-300"
            >
              {t.contact.emailLabel}
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-sm text-white focus:border-coding-color focus:outline-none"
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
              className="mt-1 text-sm text-red-500"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="message"
              className="mb-1 block text-sm text-gray-300"
            >
              {t.contact.messageLabel}
            </label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleInputChange}
              className="w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-sm text-white focus:border-coding-color focus:outline-none"
              placeholder={t.contact.messagePlaceholder}
            />
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
              className="mt-1 text-sm text-red-500"
            />
          </div>

          <div className="text-center">
            <button
              type="submit"
              disabled={state.submitting}
              className="w-32 rounded-md bg-blue-500 py-2 px-4 text-sm font-medium text-white transition hover:bg-blue-600 disabled:opacity-70"
            >
              {state.submitting ? t.contact.submitting : t.contact.submit}
            </button>
          </div>
        </form>
      </div>

      <div className="mt-10 flex flex-col items-center justify-center gap-4">
        <Social />
      </div>
      <ScrollToTop />
    </section>
  );
};

export default Contact;
